import React, { MouseEvent } from 'react';
import uuid from 'uuid-random';
import { ToolWrapper, StyledColorPicker, StyledColor } from '../Styled';
import { TEXT_TOOL_COLORS_NAME, TEXT_TOOL_COLORS } from '../../constants';

interface IMenu {
  onClick: (event: MouseEvent) => void;
  isActive: boolean;
  chosenColor: string;
  x: number;
  y: number;
}

export const TEXT_COLOR_MENU = 'TEXT_COLOR_MENU';

export const TextColorMenu = (props: IMenu): JSX.Element | null => {
  const { onClick, isActive, chosenColor, x, y } = props;

  if (!isActive) {
    return null;
  }

  return (
    <ToolWrapper data-testid="text-color-menu" className={TEXT_COLOR_MENU} x={x} y={y} margin="120px 80px 0px">
      <StyledColorPicker className={TEXT_COLOR_MENU}>
        {TEXT_TOOL_COLORS.map((color: string, index) => {
          return (
            <StyledColor
              data-testid="text-color-item"
              key={uuid()}
              onClick={onClick}
              aria-label={`${TEXT_TOOL_COLORS_NAME[index]} color button`}
              className={TEXT_COLOR_MENU}
              tabIndex={0}
              isChosen={chosenColor === color}
              color={color}
            />
          );
        })}
      </StyledColorPicker>
    </ToolWrapper>
  );
};
